import createConverter from './lib/create_converter';
import CommunicationQueue from 'models/communication_queue';

export default createConverter(CommunicationQueue);
